import { populate } from "populate";

const raw = {
  width: 1350,
  height: 760,
  x: 50,
  y: 0,
  list: [
    {
      id: "345b1096-016b-4c39-bdaf-2baa3d20b247",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "0cda70f9-c0b4-49c3-bc35-d91b766cfd3a",
      type: "Sprite",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "splash_screen_fb_logo",
      parent: "345b1096-016b-4c39-bdaf-2baa3d20b247",
      data: ""
    },
    {
      id: "e7c02dc2-0861-4704-a197-bd943861984b",
      type: "Container",
      name: "buttonsContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 548,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "345b1096-016b-4c39-bdaf-2baa3d20b247",
      data: ""
    },
    {
      id: "6be5622b-d9a1-452b-976a-d4a145878246",
      type: "Sprite",
      name: "playButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "green_button",
      parent: "e7c02dc2-0861-4704-a197-bd943861984b",
      data: ""
    },
    {
      id: "d610b930-22df-4e39-9a52-5aade04c769b",
      type: "Sprite",
      name: "connectButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 110,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "blue_button",
      parent: "e7c02dc2-0861-4704-a197-bd943861984b",
      data: ""
    },
    {
      id: "231ba4c1-54dd-49e4-872c-79524b77e9b2",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Play",
      localize: true,
      maxWidth: 177,
      maxHeight: 71,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#3A8017",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "6be5622b-d9a1-452b-976a-d4a145878246",
      data: ""
    },
    {
      id: "2a636687-672e-4ee7-8f19-8fe8064423c9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -116,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fb_icon",
      parent: "d610b930-22df-4e39-9a52-5aade04c769b",
      data: ""
    },
    {
      id: "c859e324-beda-4e46-b767-275e324b352c",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 10,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "PlayedBefore?",
      localize: true,
      maxWidth: 201,
      maxHeight: 71,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#284E93",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "d610b930-22df-4e39-9a52-5aade04c769b",
      data: ""
    }
  ]
} as const;

export class ConnectFbSplashScreenLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  bg: GameObject<PIXI.Sprite>;
  buttonsContainer: GameObject<PIXI.Container>;
  playButton: GameObject<PIXI.Sprite>;
  connectButton: GameObject<PIXI.Sprite>;

  constructor() {
    populate(this, raw);
  }
}
